import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { INTEGRATION_REATILS_FOR_EXPORT } from 'src/app/constants';
import { LanguageService } from 'src/app/services';

@Component({
  selector: 'app-export',
  templateUrl: './export.component.html',
  styleUrls: ['./export.component.css']
})
export class ExportComponent implements OnInit {

  language: string;
  subscriptions: Subscription = new Subscription();
  retails = INTEGRATION_REATILS_FOR_EXPORT;
  
  constructor(
    private languageService: LanguageService,
  ) { }

  ngOnInit(): void {
    

    this.language = this.languageService.getLanguage();

    this.subscriptions.add(
      this.languageService.listenerLanguage().subscribe(val => {

        this.language = val.language;
      })
    );
  }

  ngOnDestroy(): void {

    this.subscriptions.unsubscribe();
  }
}


